import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import WorkExperience from 'src/constants/workExperience';

export interface VacancyCreateRules {
    areaIds: {
        maxCount: number;
        minCount: number;
        required: boolean;
    };
    compensation: {
        fields: {
            compensationFrom: {
                maxValue: number;
                minValue: number;
                required: boolean;
            };
            compensationGross: {
                required: boolean;
            };
            compensationTo: {
                maxValue: number;
                minValue: number;
                required: boolean;
            };
            currencyCode: {
                required: boolean;
            };
        };
        required: boolean;
    };
    professionalRoleIds: {
        maxCount: number;
        minCount: number;
        required: boolean;
    };
    vacancyName: {
        maxLength: number;
        minLength: number;
        required: boolean;
    };
    workExperience: {
        enum: WorkExperience[];
        required: boolean;
    };
}

export default autoGeneratedReducer<VacancyCreateRules>(null);
